export default "__VITE_ASSET__DUHeY$AR__"